import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  gap: 20px;
  flex-direction: column;
`;

export default Container;
